function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { floral, useMultiStyleConfig } from "@thebouqs/system";
import { useCarousel } from "./Carousel.hooks";
import { Slider } from "./Slider";
import { DotNavigation, ArrowNavigation } from "./CarouselNavigation";
export var Carousel = _ref => {
  var {
    slides,
    seamless,
    dotNavigation,
    initialSlide = 0,
    span = 1
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["slides", "seamless", "dotNavigation", "initialSlide", "span"]);

  var {
    position,
    goTo,
    jump
  } = useCarousel(slides, span, initialSlide);
  var styles = useMultiStyleConfig("Carousel", {});
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(floral.div, {
    sx: _extends({}, styles.container, props)
  }, /*#__PURE__*/React.createElement(Slider, {
    slides: slides,
    index: position,
    goTo: goTo,
    seamless: seamless,
    span: span
  }), /*#__PURE__*/React.createElement(ArrowNavigation, {
    jump: jump,
    sx: styles.arrowNav
  })), dotNavigation ? /*#__PURE__*/React.createElement(DotNavigation, {
    count: slides.length,
    current: position,
    sx: styles.dotNav,
    goTo: goTo
  }) : null);
};
//# sourceMappingURL=Carousel.js.map